import { useContext, useEffect, useMemo, useState } from "react";
import { FilterContext } from "src/components/Common/UI/DndTable/TableFilterV2/FilterContext";
import { useGetAllSpeeds } from "../api/getAllSpeeds";
import { useTranslation } from "react-i18next";

// All your logic is here
export const useSpeedsDataViewLogic = () => {
  const { submitedFilters } = useContext(FilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({ action: "", selectedRows: [] });
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetSpeed []>([]);
  const getAllSpeedsQuery = useGetAllSpeeds({data: submitedFilters ? submitedFilters : {}});
  const { t } = useTranslation();

  const loadingDone = [getAllSpeedsQuery].every(
    ({ isFetching  }) => !isFetching
  );

  const errorData = [getAllSpeedsQuery].filter(
    ({ isError }) => (isError ? true : false)
  );

  const data = getAllSpeedsQuery.data ? getAllSpeedsQuery.data : []

  const columns = useMemo(
    () => [
      {
          id: "1",
          Header: "Ταχύτητα Γραμμής",
          accessor: "description",
          show : true,
          isDraggable: false,
      },
  
    ], []
  );

  const closeActionModal = () => {
    setModalEvent({action: "", selectedRows: []});
  }

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Δημιουργία Ταχύτητας Γραμμής");
        break;
      case "edit":
        title = t("Επεξεργασία Ταχύτητας Γραμμής");
        break
        case "delete":
        title = t("Διαγραφή Ταχύτητας Γραμμής");
        break
      default:
        break;
    }
    return title;
  }

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable[0] ? [...[selectedRowsOfTable[0].id]] : [];
    console.log("selectedRows", selectedRows, "selectedRowOfTable", selectedRowsOfTable, "selectedRowOfTable[0]", selectedRowsOfTable[0])
    setModalEvent({action: event.action, selectedRows: selectedRows})
  }

  useEffect(()=>{
    setSelectedRowsOfTable([]);
    getAllSpeedsQuery.refetch();
  },[ submitedFilters ])


  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction
  };
};
